import { defineResolver } from 'customer-flows/utils/quote/resolvers'

export default {
  availabilityTimeId: defineResolver<string | undefined>(({ resolveStoreProp, requirementsFor }) => ({
    resolve: () => {
      for (const field of requirementsFor('availability')) {
        if (!resolveStoreProp('availability', field)) return undefined
      }

      const timeslots: AvailabilityTime[] = resolveStoreProp('availability', 'validTimeslots')
      return timeslots[0]?.id
    }
  }))
}
